var _path, _ellipse, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageBgUser = function SvgImageBgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 220,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#image-bg-user_svg__a)",
    fillOpacity: 0.59,
    d: "M195.966 48.5c7-10.8 13.383-39.5-8.612-55.5l99.715 7v136.5l-6.176 5c-30.883-9.5-16.986-51.5-30.368-69-13.382-17.5-29.338-1.5-41.176 0-9.471 1.2-14.241-2.167-15.442-4-2.23-2.167-4.941-9.2 2.059-20Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.015,
    cy: 140,
    fill: "url(#image-bg-user_svg__b)",
    fillOpacity: 0.4,
    rx: 82.868,
    ry: 80
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#image-bg-user_svg__c)",
    fillOpacity: 0.76,
    d: "M134.338 20c35.824-8.4 49.927-18.833 52.5-23H-8.235v97c.857-8 9.47-29 37.058-49C63.31 20 89.56 30.5 134.339 20Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "image-bg-user_svg__a",
    x1: 268.162,
    x2: 261.847,
    y1: -13,
    y2: 148.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6805A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA08C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6805A",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "image-bg-user_svg__b",
    x1: 104.458,
    x2: 80.006,
    y1: 53.535,
    y2: 228.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6805A",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#FBA08C",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6805A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "image-bg-user_svg__c",
    x1: 149.851,
    x2: 141.884,
    y1: -6.919,
    y2: 88.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6805A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A084"
  })))));
};
export default SvgImageBgUser;